import { useQuery } from '@tanstack/react-query'
import { supabase } from '../../api'

const getServicesSingle = async (serviceIds, teamIds    ) => {
    const { data: team, error: teamError } = await supabase
        .from('services_teams')
        .select(`*, teams(*), service(*)`)
        .in('service', serviceIds)
        .in('teams', teamIds)
        // .single()

    if (teamError) {
        throw new Error(teamError.message)
    }

    return team
}

export default function useGetServicesTeamsByServiceIdSingle(serviceIds, teamIds) {
    return useQuery({
        queryKey: ['useGetServicesTeamsByServiceIdSingle', serviceIds],
        queryFn: () => getServicesSingle(serviceIds, teamIds),
        staleTime: 0,
    })
}


